import React from 'react';
import { translate } from '../../services/translate';
import Container from '../../components/Container';
import Header from '../../components/Header';
import Card from '../../components/Card';
import DataTableHeader from '../../components/DataTableHeader';
import MyDataTable from '../../components/MyDataTable';
import DropdownButton from '../../components/DropdownButton';
import { NavigationProp, useIsFocused, useNavigation } from '@react-navigation/native';
import { StreamServersParamList } from '../../typings/Params';
import DataTableContainer from '../../components/DataTableContainer';
import { useAuth } from '../../context/Auth';
import { useQuery } from '@tanstack/react-query';
import { streamServersService } from '../../services/central-api/stream-servers';


export default function ServerFarms() {
    const navigation = useNavigation<NavigationProp<StreamServersParamList>>();
    const { user: authenticatedUser } = useAuth();
    const isFocused = useIsFocused();

    const { data } = useQuery({
        queryKey: ['serverFarms'],
        queryFn: () => streamServersService.getServerFarms(),
        enabled: !!authenticatedUser && isFocused,
    });

    return <Container>
        <Header
            title={translate('serverFarms')}
        />
        <Card>
            <DataTableHeader
                title={translate('serverFarms')}
                zIndex={1}
            />
            <DataTableContainer
                dataTable={<MyDataTable
                    data={data || []}
                    pointerOnHover
                    onRowClicked={(row) => {
                        navigation.navigate('ServerFarmDetail', {
                            id: row.id,
                        });
                    }}
                    columns={[{
                        name: translate('id'),
                        cell: row => row.id,
                        minWidth: '75px',
                        grow: 0,
                    }, {
                        name: translate('company'),
                        selector: row => row.companyName,
                    }, {
                        name: '',
                        button: true,
                        wrap: true,
                        cell: (row) => {
                            return (
                                <DropdownButton
                                    actions={[{
                                        content: translate('view'),
                                        onPress: () => {
                                            navigation.navigate('ServerFarmDetail', {
                                                id: row.id,
                                            });
                                        },
                                    }]}
                                />
                            );
                        }
                    }]}
                />}
            />

        </Card>
    </Container>;
}
